import React from 'react';
import * as IconFactory from '../../services/icons.factory' 

export const SideButton = (props) => (
    <span className="sidebar-button" onClick={props.clickHandler}>
    </span>
)